import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-incorrect-route',
  templateUrl: './incorrect-route.component.html',
  // styleUrls: ['./incorrect-route.component.scss']
})
export class IncorrectRouteComponent {}
